import { ClassProvider, ExistingProvider } from '@angular/core';

import { CustomersListingModelService } from '../pages/csr/customers/customers-listing-model.service';
import { EventConfigurationListingModelService } from '../pages/administration/event-configuration/event-configuration-listing-model.service';
import { ReportGroupsListingModelService } from '../pages/administration/report-groups/report-groups-listing-model.service';
import { ReportsListingModelService } from '../pages/reporting/components/reports-list/reports-listing-model.service';
import { SubscriptionManagementListingModelService } from '../pages/administration/subscription-management/subscription-management-listing-model.service';
import { UserRolesListingModelService } from '../pages/administration/user-roles/user-roles-listing-model.service';
import { AlarmsListingModelService } from '../pages/equipment/alarms/services/alarms-listing-model.service';
import { HistoryLogListingModelService } from '../pages/equipment/history-log/components/history-log-listing-page/history-log-listing-model.service';
import { FieldOperationsServiceServiceListingModelService } from '../pages/equipment/field-operations/ui/field-operations-listing-model.service';
import { RequestProcessingListingModelService } from '../pages/equipment/twoway-request-processing/services/request-processing-listing-model.service';
import { BaseStationListingModelService } from '../pages/equipment/base-stations-listing-page/base-stations-listing-model.service';
import { MissingProgrammingRecordsListingModelService } from '../pages/equipment/issue-monitoring/missing-programming-records/missing-programming-records-listing-model.service';
import { LISTING_MODEL } from '../shared/constants/tokens';

export const missingProgrammingRecordsListingModelProvider: ClassProvider = {
  provide: LISTING_MODEL,
  useClass: MissingProgrammingRecordsListingModelService
};

export const alarmsListingModelProvider: ClassProvider = {
  provide: LISTING_MODEL,
  useClass: AlarmsListingModelService
};

export const customersModelProvider: ClassProvider = {
  provide: LISTING_MODEL,
  useClass: CustomersListingModelService
};

export const eventConfigurationModelProvider: ExistingProvider = {
  provide: LISTING_MODEL,
  useExisting: EventConfigurationListingModelService
};

export const historyLogListingModelProvider: ClassProvider = {
  provide: LISTING_MODEL,
  useClass: HistoryLogListingModelService
};

export const fieldOpertionsListingModelProvider: ClassProvider = {
  provide: LISTING_MODEL,
  useClass: FieldOperationsServiceServiceListingModelService
};

export const reportGroupsModelProvider: ExistingProvider = {
  provide: LISTING_MODEL,
  useExisting: ReportGroupsListingModelService
};

export const reportsModelProvider: ExistingProvider = {
  provide: LISTING_MODEL,
  useExisting: ReportsListingModelService
};

export const requestProcessingListingModelProvider: ClassProvider = {
  provide: LISTING_MODEL,
  useClass: RequestProcessingListingModelService
};

export const subscriptionManagementModelProvider: ClassProvider = {
  provide: LISTING_MODEL,
  useClass: SubscriptionManagementListingModelService
};

export const userRolesModelProvider: ExistingProvider = {
  provide: LISTING_MODEL,
  useExisting: UserRolesListingModelService
};
export const baseStationListingModelProvider: ClassProvider = {
  provide: LISTING_MODEL,
  useClass: BaseStationListingModelService
};
